import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=70d28ede&"
import script from "./Sites.vue?vue&type=script&lang=js&"
export * from "./Sites.vue?vue&type=script&lang=js&"
import style0 from "./Sites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports